import ApiService from '../ApiService'

const reportService = {
    orders (data) {
        return ApiService.post('/report/orders', data)
    }
}

export default reportService
